// import API_ENV from './API_ENV';
import { unionFlag } from "./index";

export const OK = 0;

// const envMap = {
//   dev: `-${'test05'}`,
//   development: `-${'test05'}`,
//   test05: `-${API_ENV}`,
//   stage: `.${API_ENV}`,
//   prd: "",
//   production: "",
// };

// console.log('当前环境：', API_ENV)
// export const bfdApi = `//${unionFlag()}-corp${envMap[API_ENV]}.dongfangfuli.com`;

const { origin } = window.location;
let env = "";
if (origin.indexOf(".test05") > -1 || origin.indexOf("-test05") > -1) {
  env = "-test05";
} else if (origin.indexOf(".stage") > -1 || origin.indexOf("-stage") > -1) {
  env = ".stage";
} else {
  env = "";
}
export const bfdApi = window.df_sdk_common.grayDomain(
  `//${unionFlag()}-corp${env}.dongfangfuli.com`
);
